import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  "@keyframes rippleEffect": {
    "0%": {
      transform: "scale(1)",
      opacity: 1,
    },
    "33%": {
      opacity: 1,
    },
    "100%": {
      transform: "scale(9)",
      opacity: 0
    },
  },
  ripple: {
    background: 'transparent',
    border: "1px solid #000",
    borderRadius: '50%',
    pointerEvents: 'none',
    display: 'block',
    position: 'absolute',
    animation: "0.5s $rippleEffect linear",
  }
}));

const RIPPLE_SIZE: number = 12;

type RippleProps = {
  key: number,
  style: Object,
};

export default function useMouseRipple(style: Object = {}) {
  const classes = useStyles();
  const [ripples, setRipples] = useState<RippleProps[]>([])
  const [key, setKey] = useState<number>(0);

  const addRipple: (x: number, y: number) => void = (x: number, y: number) => {
    const newRipple = {
      key: key,
      style: {
        width: RIPPLE_SIZE,
        height: RIPPLE_SIZE,
        left: x - RIPPLE_SIZE / 2,
        top: y - RIPPLE_SIZE / 2,
        ...style
      }
    }
    setKey(prev => prev+1);
    setRipples(state => [...state, newRipple])
  }

  const rippleComponents = ripples.map(currentRipple => {
    const handleAnimationEnd = () => {
      setRipples(state => state.filter(previousRipple => previousRipple.key !== currentRipple.key))
    }

    return <span className={classes.ripple} {...currentRipple} onAnimationEnd={handleAnimationEnd} />
  })

  return {rippleComponents, addRipple}
}